// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu {\r\n  background-color: red;\r\n}\r\n\r\n.wyzydiv .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {\r\n  border-right-color: #3AC5A8 !important;\r\n  border-left-color: #3AC5A8 !important;\r\n  background-color: #3AC5A8 !important;\r\n  color: black !important;\r\n}", ""]);
// Exports
module.exports = exports;
